import { MutationTree } from 'vuex';

import { encode } from '@/utils/custom-enc-dec';

import {
  FirestoreStateI,
  FirestoreDocsI,
  FirestoreDocI,
  FirestoreDocumentI,
  FirestoreDatabaseI,
} from './state';

export const mutations: MutationTree<FirestoreStateI> = {

  setDatabases(state: FirestoreStateI, payload: FirestoreDatabaseI[]) {
    const dbsmapped = payload.map((db) => ({
      ...db,
      formatedName: db.name.split('/').pop() || db.name,
    }));
    state.databases = dbsmapped;
  },

  setCollections(state: FirestoreStateI, payload: string[]) {
    localStorage.removeItem('fscols');
    state.collectionIds = [];
    if (!payload) {
      return;
    }
    state.collectionIds = payload;
    const colsenc = encode(payload);
    localStorage.setItem('fscols', colsenc);
  },

  setDocuments(state: FirestoreStateI, payload: FirestoreDocsI[]) {
    state.docs = payload;
  },

  setDocument(state: FirestoreStateI, payload: FirestoreDocI) {
    state.doc = payload;
  },

  setSubcollections(state: FirestoreStateI, payload: string[]) {
    if (!payload) {
      return;
    }
    state.subcollections = payload;
  },

  setDocumentsInSubcollection(state: FirestoreStateI, payload: FirestoreDocumentI[]) {
    state.documentsInSubcollection = payload;
  },

};
